<template>
  <div class="account-add wbg">
    <div class="center-form">
      <Rule ref='rules' :cktree="curAcc.accuser_role_id" :curAcc='curAcc' :edit='edit' :tree='rouleGroup'
        :listAccuser='accuserList'></Rule>
      <a-form-model ref="addForm" :model="form" :rules="rules" hideRequiredMark :label-col="{ span: 4 }"
        :wrapper-col="{ span: 20 }" class="flexbox">
        <a-row :gutter="24" type="flex">
          <a-col :span="10">
            <a-form-model-item label="账号名称：" prop="uname">
              <a-input v-model="form.uname" placeholder="请设置账号名称" :maxLength='8' style="width: 100%;" />
            </a-form-model-item>
          </a-col>
          <a-col :span="10">
            <a-form-model-item label="账号密码：" prop="password">
              <a-input v-model="form.password" type="password" placeholder="请设置密码" style="width: 100%;" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24" type="flex">
          <a-col :span="10">
            <a-form-model-item label="所属公司" prop="title">
              <a-select show-search v-model="form.title" placeholder="请选择" :allowClear='true'
                :default-active-first-option="false" :show-arrow="false" :filter-option="false"
                :not-found-content="null" @search="handleSearch">
                <a-select-option v-for="item in comList" :key="item.title" :value="item.title">{{ item.title
                }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="10">
            <a-form-model-item label="手机号：" prop="phone">
              <a-input v-model="form.phone" placeholder="请设置手机号" style="width: 100%;" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24" type="flex">
          <a-col :span="10">
            <a-form-model-item label="是否禁用：" prop="audit">
              <a-switch checked-children="启用" un-checked-children="禁用" default-checked v-model='form.audit' />
            </a-form-model-item>
          </a-col>
          <a-col :span="10">
            <a-form-model-item label="基础权限" prop="menu_ids">
              <a-tree-select :maxTagCount='1' :maxTagTextLength='5' v-model="form.menu_ids" style="width: 100%"
                :tree-data="treeData" tree-checkable :showCheckedStrategy="SHOW_ALL" :replace-fields="replaceFields"
                allow-clear />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24" type="flex">
          <a-col :span="10">
            <a-form-model-item label="用户组" prop="user_group_id">
              <a-select show-search v-model="form.user_group_id" placeholder="请选择" :allowClear="true"
                :default-active-first-option="false" :show-arrow="false" :filter-option="false"
                :not-found-content="null">
                <a-select-option v-for="item in user_group" :key="item.id" :value="item.id">{{ item.title
                }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24" type="flex">
          <a-col :span="10">
            <a-form-model-item label="关联原告：" prop="accuser">
              <a-select mode="multiple" allowClear v-model="form.accuser" @change="accuserChange"
                @select="accuserSelect" placeholder="请选择" style="width: 100%;" :maxTagCount='1' :maxTagTextLength='5'
                v-if='!id'>
                <a-select-option value="-1">全部</a-select-option>
                <a-select-option v-for="item in accuserList" :key="item.title" :value="item.id">{{ item.title
                }}</a-select-option>
              </a-select>
              <a-button type="primary" style="height:30px;" @click="addAcc">新增原告</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24" type="flex">
          <a-col :span="18">
            <a-form-model-item label="原告权限：" labelAlign='left' :labelCol="{ span: 2 }">

              <ul class="nul">
                <li v-for='i in listAccuser' :key="i.id">
                  <span v-if='i.accuser' style="width:240px;">
                    <Normap :tit='i.accuser.title'></Normap>
                  </span>
                  <span v-if='i.accuser' style="width: 250px;">
                    <!-- <div v-for="j in i.roles" :key="j.id">{{ rouleGroupChange(j.accuser_role_id) }}</div> -->
                    <Normap :tit='rouleGroupChange(i.roles)'></Normap>
                  </span>
                  <div class="btns">
                    <a href='javascript:void(0);' @click='setRule(i)'>原告权限</a>
                    <a-popconfirm title="确认删除此原告权限吗?" ok-text="确定" cancel-text="取消" @confirm="del(i)">
                      <a href='javascript:void(0);' class='del'>删除</a>
                    </a-popconfirm>
                  </div>
                </li>
              </ul>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-form-model-item>
          <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="onSubmit">
            <a-button type="primary" style="margin-left:80px;">提交</a-button>
          </a-popconfirm>
          <a-button class="cancel" type="primary" @click="cancel()" style="margin-left: 30px;  background-color: #b2c9e1;
  border-color: #b2c9e1;">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
  </div>
</template>
<script>
import { getAccuserAll } from '@/server/api'
import { accountInfo, accList, userEdit, userCom, accDel, userGrounp } from '@/server/user'
import { list } from '@/power/api'
import { TreeSelect } from 'ant-design-vue';
import { accuserRole } from '@/server/user'
import Rule from './rule.vue'
import Validator from "@/assets/js/yz.js"
export default {
  data() {
    return {
      edit: 0,    //0 编辑 1新增
      curAcc: {},
      id: this.$route.query.id || '',
      SHOW_ALL: TreeSelect.SHOW_ALL,
      replaceFields: {
        children: 'child',
        title: 'title',
        key: 'id',
        value: 'id'
      },
      user_group: [],
      comList: [],
      form: {
        user_group_id: '',
        phone: '',
        accuser: [''],
        menu_ids: [],
        title: '',
        uname: '',
        password: '',
        audit: true
      },
      rouleGroup: [],
      treeData: [],
      rules: {
        // group: { required: true, message: '请选择权限', trigger: 'change', validator: this.arrayValidator },
        user_group_id: [{ required: true, trigger: 'change' }],  //
        phone: [{ required: false, trigger: 'blur', validator: Validator.tels }],  //
        title: { required: true, message: '请选择所属公司', trigger: 'blur' },
        uname: { required: true, message: '请设置账号名称', trigger: 'blur' },
        password: { message: '请设置密码', trigger: 'blur', validator: this.passwordValidator }
      },
      listAccuser: [],    //详情原告
      accuserList: [],    //所有原告
      groupList: []
    }
  },
  components: { Rule },
  created() {
    this.getAccuser()
    list({ belong: 1, status: 1 }).then(e => {
      this.treeData = e;
    })
    accuserRole('index', { limit: 100 }).then(e => {
      this.rouleGroup = e.list
    })
    this.handleSearch()
    userGrounp('index').then((res) => {
      this.user_group = res.list;
    })
  },
  methods: {
    addAcc() {
      this.curAcc = { user_id: this.id, accuser_id: 0, accuser_role_id: [] }
      this.edit = 1
      setTimeout(e => {
        this.$refs.rules.visible = true;
      }, 200)

    },
    rouleGroupChange(val) {
      if (val.length == 0) {
        return '无';
      }
      // 确保val是数组
      const ids = Array.isArray(val) ? val : [val];
      // 使用filter和map来获取对应的title并拼接
      const titles = ids.map(id => {
        const found = this.rouleGroup.find(ele => ele.id == id.accuser_role_id);
        return found ? found.title : '';
      }).filter(title => title !== '');
      return titles.join(', ');
    },
    del(i) {
      accDel({ user_id: i.user_id, accuser_id: i.accuser_id }).then(e => {
        this.$message.success('已删除原告权限')
        this.getAccuser()
      })
    },
    setRule(item) {
      const accuser_role_id = item.roles.map(ele => {
        return ele.accuser_role_id
      })
      this.curAcc = { user_id: this.id, accuser_id: item.accuser_id, accuser_role_id: accuser_role_id }
      this.edit = 0
      setTimeout(e => {
        this.$refs.rules.visible = true;
      }, 200)
    },
    handleSearch(val) {
      userCom({ title: val }).then(e => {
        this.comList = e.list
      })
    },
    getInfo(Arr) {
      accountInfo({
        id: this.id
      }).then((res) => {
        for (const key in this.form) {
          this.form[key] = res.info[key]
        }
        Arr.map(element => {
          res.info.accuser.map(ele => {
            if (element.id == ele.accuser_id) {
              element.disabled = true
            }
          })
        })
        if (!res.info.user_group_id || res.info.user_group_id <= 0) {
          this.form.user_group_id = undefined
        }

        this.accuserList = Arr
        this.form.audit = res.info.audit == 1 ? true : false
        this.listAccuser = res.info.accuser
        this.form.phone = res.info.phone
        this.form.accuser = []
        this.form.menu_ids = res.menu_ids
        if (Arr.length == res.info.accuser.length) {
          this.form.accuser = ['-1']
        } else {
          res.info.accuser.forEach(element => {
            this.form.accuser.push(element.accuser_id)
          });
        }
      })
    },
    getAccuser() {
      getAccuserAll().then((res) => {
        //  this.accuserList = res.list
        this.getInfo(res.list)
      })
    },
    accuserChange(val) {
      if (val.length === 0) {
        this.form.accuser = ['']
      }
    },
    accuserSelect(val) {
      if (val === '-1') {
        this.form.accuser_rule = 1
        this.form.accuser = ['-1']
      } else {
        this.form.accuser_rule = 2
        this.form.accuser = this.form.accuser.filter((ele) => {
          return ele !== '-1'
        })
      }
    },
    arrayValidator(rule, value, callback) {
      if (value.length > 0) {
        callback();
      } else {
        return callback(new Error(rule.message));
      }
    },
    passwordValidator(rule, value, callback) {
      if ((value == '' || value == null || value == undefined) && this.id === '') {
        return callback(new Error(rule.message));
      }
      callback();
    },
    onSubmit() {
      this.$refs.addForm.validate(valid => {
        let form = JSON.parse(JSON.stringify(this.form))
        form.audit = form.audit ? 1 : 0
        if (valid) {
          userEdit(Object.assign(form, { id: this.id })).then((res) => {
            this.$message.success({ content: '修改成功' });
            this.$router.replace('/account/manager');
          })
        }
      })
    },
    cancel() {
      this.$router.replace('/account/manager');
    }
  }
}
</script>
<style lang="less" scoped>
.flexbox {
  width: 1100px;
}

.account-add {
  padding-top: 30px;
  min-height: 860px;
}

.ant-checkbox-group {
  padding-top: 6px;
}

.ant-form-item label {
  width: 150px;
  margin-left: 0;
  margin-bottom: 24px;
}

.ant-form-item {
  margin-bottom: 20px;
}

.ant-form-item-with-help {
  margin-bottom: 11px;
}

// button.ant-btn {
//   width: 148px;
//   margin-top: 10px;
// }
.del {
  color: #f00;
  margin-left: 10px;
}

.nul {
  padding-left: 10px;

  li {
    display: flex;
    justify-content: space-between;
  }
}
</style>
